var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgModelsPipelineDeleteIcon = function SvgModelsPipelineDeleteIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ModelsPipelineDeleteIcon_svg__a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#EAECF2"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    clipPath: "url(#ModelsPipelineDeleteIcon_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "m7.979 15.996-1.374-7.13h10.79l-1.374 7.13c-.096.5-.163.847-.238 1.116-.072.261-.141.411-.224.524a1.5 1.5 0 0 1-.57.47c-.126.06-.286.1-.557.122-.277.022-.63.022-1.14.022h-2.583c-.51 0-.864 0-1.141-.022-.27-.022-.43-.062-.558-.122a1.5 1.5 0 0 1-.569-.47c-.083-.113-.152-.263-.225-.524a16 16 0 0 1-.237-1.116Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5 8.05v.654h-5V8.05a2.5 2.5 0 0 1 5 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M13.5 12h-3M6 8.733h12"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ModelsPipelineDeleteIcon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ModelsPipelineDeleteIcon_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5 5h14v14H5z"
  })))));
};
export default SvgModelsPipelineDeleteIcon;